import { render, staticRenderFns } from "./UserPoint.vue?vue&type=template&id=430a8c55&"
import script from "./UserPoint.vue?vue&type=script&lang=ts&"
export * from "./UserPoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports